// -----------------------------------------------------------------
// Embroidery editor configuration (OP-39631)
// -----------------------------------------------------------------

// Digitization constraints
// Source: gelato-api-dashboard libs/core/design-editor/constants/desgin-editor-validation-config.ts
export const EMBROIDERY_MAX_COLOR_COUNT = 6;
export const EMBROIDERY_MAX_STITCH_COUNT = 10000;
export const EMBROIDERY_MIN_FONT_SIZE = 24;

// Thread color palette
// Fetched at runtime from PreFlight CDN: GET {preFlightCdnBaseUrl}/embroidery/palette
// CDN URL derived from integration layer's preFlightApiBaseUrl (preflight. → preflight-cdn.)
export const EMBROIDERY_PALETTE_ENDPOINT = '/embroidery/palette';

export interface EmbroideryPaletteItem {
  name: string;
  hex: string;
  madeira_ref: string;
}

export interface ColorPickerConfig {
  enableOpacity: boolean;
  allowedColors: string[];
  colorsInfo: { [hex: string]: { name: string; madeira_ref: string } };
}
